import script from "./TaskChipPicker.vue?vue&type=script&setup=true&lang=js"
export * from "./TaskChipPicker.vue?vue&type=script&setup=true&lang=js"

import "./TaskChipPicker.vue?vue&type=style&index=0&id=74db21eb&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-74db21eb"]])

export default __exports__